import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import { Text, Icon } from '../Elements';
import { showNotif } from 'utils/notification';

import classes from './TextCopyForTooltip.module.scss';

const TextCopyForTooltip = ({ text, notification }) => {
  const { t } = useTranslation(['activity']);

  return (
    <>
      <Text className={classes.text} size={2}>
        {text}
      </Text>
      <Icon
        icon="copy"
        size="14px"
        className={classes.icon}
        onClick={() => {
          navigator.clipboard
            .writeText(text)
            .then(() => {
              showNotif({
                message: t(notification, { text }),
                kind: 'success',
                dismissAfter: 5000,
                type: 'alert'
              });
            })
            .catch(err => console.log(err));
        }}
      />
    </>
  );
};

TextCopyForTooltip.propTypes = {
  text: PropTypes.string,
  notification: PropTypes.string
};

export default TextCopyForTooltip;
